import { SEARCHING_AIRPORTS } from '../../actions/common';

export default function airportLoading(state = {}, action) {
  switch (action.type) {
    case SEARCHING_AIRPORTS:
      return {
        ...state,
        [action.code]: action.isFetching,
      };

    default:
      return state;
  }
}
